export default __webpack_public_path__ + "static/cards-es@2x-e03b0ebf5b8a07fd74d5dfbb1ae57ede.png";